var _path, _mask;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 1.95833C24 1.70522 23.7948 1.5 23.5417 1.5H18.3478C17.9407 1.5 17.7352 1.99384 18.0237 2.28243L19.8642 4.12341L9.46757 14.52C9.28861 14.699 9.28861 14.9892 9.46757 15.1682L10.3318 16.0325C10.5108 16.2114 10.801 16.2114 10.98 16.0325L21.3766 5.63589L23.2176 7.47654C23.5046 7.76352 24 7.56191 24 7.15248V1.95833ZM18.3287 10.4122C18.6174 10.1235 19.1111 10.328 19.1111 10.7363V19.2222C19.1111 20.2347 18.2903 21.0556 17.2778 21.0556H3.83333C2.82081 21.0556 2 20.2347 2 19.2222V5.77778C2 4.76525 2.82081 3.94444 3.83333 3.94444H16.8185C17.2269 3.94444 17.4314 4.43814 17.1426 4.72687L16.2259 5.64354C16.1518 5.71761 16.0067 5.77778 15.9018 5.77778H4.0625C3.93602 5.77778 3.83333 5.88046 3.83333 6.00694V18.9931C3.83333 19.1195 3.93602 19.2222 4.0625 19.2222H17.0486C17.1751 19.2222 17.2778 19.1195 17.2778 18.9931V11.653C17.2778 11.5314 17.326 11.4148 17.412 11.3289L18.3287 10.4122Z",
    fill: "#0A0D0D"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 22,
    height: 21
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 1.95833C24 1.70522 23.7948 1.5 23.5417 1.5H18.3478C17.9407 1.5 17.7352 1.99384 18.0237 2.28243L19.8642 4.12341L9.46757 14.52C9.28861 14.699 9.28861 14.9892 9.46757 15.1682L10.3318 16.0325C10.5108 16.2114 10.801 16.2114 10.98 16.0325L21.3766 5.63589L23.2176 7.47654C23.5046 7.76352 24 7.56191 24 7.15248V1.95833ZM18.3287 10.4122C18.6174 10.1235 19.1111 10.328 19.1111 10.7363V19.2222C19.1111 20.2347 18.2903 21.0556 17.2778 21.0556H3.83333C2.82081 21.0556 2 20.2347 2 19.2222V5.77778C2 4.76525 2.82081 3.94444 3.83333 3.94444H16.8185C17.2269 3.94444 17.4314 4.43814 17.1426 4.72687L16.2259 5.64354C16.1518 5.71761 16.0067 5.77778 15.9018 5.77778H4.0625C3.93602 5.77778 3.83333 5.88046 3.83333 6.00694V18.9931C3.83333 19.1195 3.93602 19.2222 4.0625 19.2222H17.0486C17.1751 19.2222 17.2778 19.1195 17.2778 18.9931V11.653C17.2778 11.5314 17.326 11.4148 17.412 11.3289L18.3287 10.4122Z",
    fill: "white"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.8b16c151.svg";
export { ForwardRef as ReactComponent };